'use client';

import { RotatingLines } from 'react-loader-spinner';

type Props = {
  size?: string;
  strokeColor?: string;
};

export default function Loading({
  size = '64',
  strokeColor = '#666666',
}: Props) {
  return (
    <div className='h-full w-full flex items-center justify-center'>
      <RotatingLines
        visible={true}
        strokeColor={strokeColor}
        width={size}
        strokeWidth='1'
        ariaLabel='rotating-lines-loading'
      />
    </div>
  );
}
